import { ReactNode, useMemo } from "react";
import { useLocation, Location, Link } from "react-router-dom";

type ScopeSpecificLinkProps = {
  hasNotification?: boolean;
  icon: ReactNode;
  route: string;
};

export const ScopeSpecificLink = ({ hasNotification = false, icon, route }: ScopeSpecificLinkProps) => {
  const location: Location = useLocation();

  const className: string = useMemo(
    () =>
      `position-relative align-center d-flex header-button py-0 px-4 ${location.pathname === route ? "active" : ""}`,
    [location, route]
  );

  return (
    <Link className={className} to={route} id={route}>
      {icon}
      {hasNotification && <span className="has-messages position-absolute" />}
    </Link>
  );
};
